module.exports = __webpack_public_path__ + "FondoTituloServicios.c409b5ff97057484a822.png";


//////////////////
// WEBPACK FOOTER
// /mnt/c/Dev/CoolDevs/modos/app/src/assets/Servicios/FondoTituloServicios.png
// module id = ../../../../../src/assets/Servicios/FondoTituloServicios.png
// module chunks = styles